import type React from 'react';

import { useSettings } from '@/core/providers/SettingsProvider';
import { CompanyLandingRouter } from '@/routes/companyLanding/router';
import { EndClientAreaRouter } from '@/routes/endClientArea/router';

export const AppRouter: React.FC = () => {
	const settings = useSettings();

	if (settings.mode === 'companyLanding') {
		return <CompanyLandingRouter />;
	}

	if (settings.mode === 'endClientArea') {
		return <EndClientAreaRouter />;
	}

	return null;
};
